import { useState } from "react";
import { useAuth } from "../lib/auth";

const colors = {
  white: "#ffffff",
  parchment: "#fce8d5",
  terra: "#6b3fa0",
  ink: "#3d1e5c",
  inkLight: "#b07a80",
};

const fontStack = "'Georgia', 'Times New Roman', serif";

/**
 * Small fixed-position chip in the top-right showing the signed-in user's
 * avatar/initial. Click to reveal a sign-out menu.
 */
export default function UserChip() {
  const { state, signOutUser } = useAuth();
  const [open, setOpen] = useState(false);

  if (state.status !== "signedIn") return null;

  const { user } = state;
  const initial =
    user.displayName?.trim().charAt(0).toUpperCase() ??
    user.email?.charAt(0).toUpperCase() ??
    "?";

  return (
    <div
      style={{
        position: "fixed",
        top: 12,
        right: 12,
        zIndex: 50,
        fontFamily: fontStack,
      }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Account menu"
        aria-expanded={open}
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          background: colors.terra,
          color: colors.white,
          border: `2px solid ${colors.white}`,
          boxShadow: "0 2px 10px rgba(45,32,22,0.15)",
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 700,
          fontFamily: fontStack,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          overflow: "hidden",
        }}
      >
        {user.photoURL ? (
          <img
            src={user.photoURL}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            referrerPolicy="no-referrer"
          />
        ) : (
          initial
        )}
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: 44,
            right: 0,
            background: colors.white,
            border: `1px solid ${colors.parchment}`,
            borderRadius: 12,
            boxShadow: "0 4px 18px rgba(45,32,22,0.12)",
            padding: 12,
            minWidth: 220,
          }}
        >
          <div
            style={{
              fontSize: 13,
              color: colors.ink,
              fontWeight: 600,
              marginBottom: 2,
              wordBreak: "break-word",
            }}
          >
            {user.displayName ?? "Signed in"}
          </div>
          <div
            style={{
              fontSize: 11,
              color: colors.inkLight,
              marginBottom: 12,
              wordBreak: "break-all",
            }}
          >
            {user.email}
          </div>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              void signOutUser();
            }}
            style={{
              width: "100%",
              padding: "8px 12px",
              background: "none",
              color: colors.terra,
              border: `1px solid ${colors.parchment}`,
              borderRadius: 8,
              cursor: "pointer",
              fontFamily: fontStack,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
